module.exports = __webpack_public_path__ + "static/media/12.eb5c883d.jpg";